import * as React from 'react';
import { useState, useEffect } from 'react';

/** Material UI Packages. */
import { Box, Chip, Paper } from '@mui/material';

/** Material UI Icons. */
import CommentContent from './CommentContent';
import { progressNoteEntries } from 'shared/config/constantsData';

export default function CommentBox(props) {
    /** Get props from Comment.js */
    const { comments, tabValue, replyMode, editMode, handlers } = props;

    const mainComment = comments[0];
    /** Reply comments of mainComment. */
    const subComments = comments.slice(1);

    /** Check if a reply is being wrtten for the main comment. */
    const isReplying = mainComment.id === replyMode.replyRow.id;

    return (
        <Paper
            sx={{
                bgcolor: 'white',
                border: isReplying ? '2px solid #d92936' : 'white',
                borderRadius: 3,
                overflow: 'auto',
                p: 1,
                mb: 1,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Chip
                    label={mainComment.il_type === 'todo' ? 'TO DO' : 'NOTE'}
                    sx={{
                        bgcolor: mainComment.il_type === 'todo' ? '#ea4c89' : '#F6BD60',
                        color: 'white',
                        fontWeight: 500,
                        p: 0,
                        height: '24px',
                    }}
                />
                {mainComment.il_type === 'note' && mainComment.note_entry && (() => {
                    const entry = progressNoteEntries[tabValue]?.find((o) => o.value === mainComment.note_entry);
                    return entry ? (
                        <Chip
                            label={entry.label}
                            size="small"
                            sx={{
                                bgcolor: '#e8f4f8',
                                color: '#003a52',
                                fontSize: '11px',
                                height: '20px',
                                fontWeight: 500,
                            }}
                        />
                    ) : null;
                })()}
            </Box>
            <Box>
                <CommentContent comment={mainComment} editMode={editMode} handlers={handlers} />
            </Box>
            {subComments.map((comment, index) => (
                <CommentContent
                    comment={comment}
                    editMode={editMode}
                    key={index}
                    parentType={mainComment.il_type}
                    handlers={handlers}
                />
            ))}
        </Paper>
    );
}
